export default __webpack_public_path__ + "static/media/ag-grey.fe185096.svg";